import StrikingDrillsEditor from './shared/StrikingDrillsEditor';
import TechniquesEditor from './shared/TechniquesEditor';
import SparringSection from './shared/SparringSection';

export default function MMAForm({ form, set, friends, sparRounds, setSparRounds, sparMin, setSparMin }) {
    const sp = form._sportConfig;
    return (
        <>
            <div className="form-group">
                <label className="form-label">오늘의 주제</label>
                <input
                    className="form-input"
                    placeholder={sp?.focusPlaceholder || '오늘의 주제'}
                    value={form.focus || ''}
                    onChange={e => set('focus', e.target.value)}
                />
            </div>
            <div className="form-group">
                <label className="form-label">훈련 구성</label>
                <StrikingDrillsEditor
                    drills={form.strikingDrills || []}
                    onChange={val => set('strikingDrills', val)}
                />
            </div>
            <div className="form-group">
                <label className="form-label">기술 / 드릴 / 포인트</label>
                <TechniquesEditor
                    techniques={form.techniques}
                    onChange={val => set('techniques', val)}
                    showResult={true}
                />
            </div>
            <SparringSection
                form={form}
                set={set}
                friends={friends}
                sparRounds={sparRounds}
                setSparRounds={setSparRounds}
                sparMin={sparMin}
                setSparMin={setSparMin}
            />
        </>
    );
}
